import {
  setOrganizationIdLocalStorage,
  setOrganizationIdSessionStorage,
  removeOrganizationId,
} from '@config/storage';
import { UserTypes } from './user.reducer';

export const OrganizationTypes = {
  SET_ORGANIZATION_DATA: 'SET_ORGANIZATION_DATA',
  CLEAR_ORGANIZATION_DATA: 'CLEAR_ORGANIZATION_DATA',
};

export const setOrganizationData = (data: {
  organizationId: string;
  name: string;
  status?: string;
}) => {
  // Store organization ID in BOTH storages to ensure it's available regardless of rememberMe state
  // This prevents issues where the organization ID is not found after page reload
  setOrganizationIdLocalStorage(data.organizationId);
  setOrganizationIdSessionStorage(data.organizationId);

  return {
    type: OrganizationTypes.SET_ORGANIZATION_DATA,
    data: data,
  };
};

export const clearOrganizationData = () => {
  // Clear organization ID from both storages
  removeOrganizationId();

  return {
    type: OrganizationTypes.CLEAR_ORGANIZATION_DATA,
  };
};

export type OrganizationState = {
  organizationId: string | null;
  name: string | null;
  status: string | null;
};

// INITIAL STATE
const organizationInitialState: OrganizationState = {
  organizationId: null,
  name: null,
  status: null,
};

export type OrganizationAction = {
  type: string;
  data?: { organizationId: string; name: string; status?: string };
};

const organizationReducer = (
  state = organizationInitialState,
  action: OrganizationAction | any,
) => {
  switch (action.type) {
    case OrganizationTypes.SET_ORGANIZATION_DATA:
      if (!action.data) {
        return state;
      }
      return {
        ...state,
        organizationId: action.data.organizationId,
        name: action.data.name,
        status: action.data.status || null,
      };

    case OrganizationTypes.CLEAR_ORGANIZATION_DATA:
    case UserTypes.LOGOUT_USER:
      // Clear organization data when user logs out or when explicitly cleared
      removeOrganizationId();
      return {
        ...organizationInitialState,
      };

    default:
      return state;
  }
};

export default organizationReducer;
